import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { store } from "./store";
import RawDataComponent from "./components/raw/RawData";
import RawDataDetailComponent from "./components/raw/RawDataDetail";

type RawDataProps = {
  basePath: string;
  apiUrl: string;
};

const RawData = ({ basePath, apiUrl }: RawDataProps) => (
  <div id="dacom-online">
    <Router>
      <Provider store={store}>
        <Route path={basePath} exact>
          <RawDataComponent apiUrl={apiUrl} />
        </Route>
        <Route path={`${basePath}/:sensorId/detail`}>
          <RawDataDetailComponent basePath={basePath} apiUrl={apiUrl} />
        </Route>
      </Provider>
    </Router>
  </div>
);

export default RawData;
